import React from 'react';

import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

const PedomanGCG = () => {
    return (
        <section className="bg-white pt-10">
            <div className="container mx-auto pt-10">
                {/* Header Section */}
                <div className="mb-12">
                    <h2 className="text-3xl font-bold text-[#005da2] mb-6 text-center" data-aos="fade-down">Pedoman GCG</h2>
                    <p className="text-lg text-gray-700 leading-relaxed text-justify" data-aos="fade-down">
                        
                    </p>
                </div>
            </div>
        </section>
    );
};

export default PedomanGCG;
